import React, {useEffect} from 'react';
import { useSelector } from 'react-redux';
import useRouter from '../../utils/hooks/useRouter';

import AuthUser from './components/AuthUser';
import AuthCompany from './components/AuthCompany';

import './style.scss';

import logo from '../../assets/logo_optim.png';

function Auth() {
    const coreState = useSelector(state => state.core);
    const authState = useSelector(state => state.auth);
    const router = useRouter();

    useEffect(function() {
        if (authState.offlinemode || authState.logguedAsCompany && authState.logguedAsUser) {
            router.push('/app');
        }
    }, [authState, router]);

    if (!coreState.ready) {
        return null;
    }

    return (
        <div className="module-auth">
            <div className="img-auth">
                <img alt="Optim'BTP" className="app-logo" src={logo}/>
            </div>
            <div className="auth-panel">
                {
                    authState.logguedAsCompany ? <AuthUser /> : <AuthCompany />
                }
            </div>

        </div>
    );
}

export default Auth;
